export default {
  siteTitle: '東京カメラ部 日本写真100景 ～日本は発見を待っている。～',
  siteDescription: '「日本写真100景フォトコンテスト」の入賞作品を各地の魅力と共にご紹介するスペシャルサイトです。',
  siteOgImage: '/img/ogimage.png',
  siteUrl: 'https://japanphotospot.tokyocameraclub.com/'
}
